import { createApi } from "@reduxjs/toolkit/query/react";
import { fetchBaseQueryByAxios } from "@/redux/api/fetchBaseQueryHelper";
import _ from "lodash";

/**
 * https://redux-toolkit.js.org/rtk-query/api/fetchBaseQuery#prepareheaders
 * here to learn more about the query
 * or see
 * `postSlice-example`, `userSlice-example`
 */
export const recordApi = createApi({
	reducerPath: "record",
	baseQuery: fetchBaseQueryByAxios,
	endpoints: (builder) => ({
		getRecord: builder.query({
			query: ({ year, month, userId }) =>
				`/records/queryRecordData?year=${year}&month=${month}&userId=${userId}`,
			transformResponse: (responseData) => {
				if (_.isEmpty(responseData.data)) {
					responseData.data = null;
				}
				return responseData.data;
			},
		}),
		getUserList: builder.query({
			query: ({ roleId }) =>
				`/userDetail/queryUserDetailByRole?role_id=${roleId}`,
			transformResponse: (responseData) => {
				if (_.isEmpty(responseData.data)) {
					responseData.data = null;
				}
				console.log(responseData);
				return responseData.data;
			},
		}),
		updateRecordByProductId: builder.mutation({
			query: (initialPost) => {
				return {
					url: "/records/recordByProductId",
					method: "PUT",
					body: initialPost,
				};
			},
		}),
		addNewRecord: builder.mutation({
			query: (initialPost) => {
				return {
					url: "/records/newRecord",
					method: "POST",
					body: initialPost,
				};
			},
		}),
		getReceptionVolumeByDate: builder.query({
			query: ({ startDate, endDate }) =>
				`/records/receptionVolumeByDay?begin_date=${startDate}&end_date=${endDate}`,
			transformResponse: (responseData) => {
				return responseData.data;
			},
		}),
		getReceptionVolumeByDayAndProduct: builder.query({
			query: ({ startDate, endDate }) =>
				`/records/receptionVolumeByDayAndProduct?begin_date=${startDate}&end_date=${endDate}`,
			transformResponse: (responseData) => {
				return responseData.data;
			},
		}),
		getReceptionVolumeByDayAndUser: builder.query({
			query: ({ startDate, endDate }) =>
				`/records/receptionVolumeByDayAndUser?begin_date=${startDate}&end_date=${endDate}`,
			transformResponse: (responseData) => {
				return responseData.data;
			},
		}),
		getReceptionVolumeByMonth: builder.query({
			query: ({ startDate, endDate }) =>
				`/records/receptionVolumeByMonth?begin_date=${startDate}&end_date=${endDate}`,
			transformResponse: (responseData) => {
				return responseData.data;
			},
		}),
		getReceptionVolumeByMonthAndProduct: builder.query({
			query: ({ startDate, endDate }) =>
				`/records/receptionVolumeByMonthAndProduct?begin_date=${startDate}&end_date=${endDate}`,
			transformResponse: (responseData) => {
				return responseData.data;
			},
		}),
		getReceptionVolumeByMonthAndUser: builder.query({
			query: ({ startDate, endDate }) =>
				`/records/receptionVolumeByMonthAndUser?begin_date=${startDate}&end_date=${endDate}`,
			transformResponse: (responseData) => {
				return responseData.data;
			},
		}),
		deleteRecord: builder.mutation({
			query(id) {
				return {
					url: `/records/deleteRecord?record_id=${id}`,
					method: "DELETE",
				};
			},
		}),
	}),
});

export const {
	useGetReceptionVolumeByDateQuery,
	useGetReceptionVolumeByDayAndProductQuery,
	useGetReceptionVolumeByDayAndUserQuery,
	useGetReceptionVolumeByMonthAndProductQuery,
	useGetReceptionVolumeByMonthAndUserQuery,
	useGetReceptionVolumeByMonthQuery,
	useGetRecordQuery,
	useGetUserListQuery,
	useUpdateRecordByProductIdMutation,
	useAddNewRecordMutation,
	useDeleteRecordMutation,
} = recordApi;
